import React, { useEffect, useState } from 'react';
import { I18n } from '@aws-amplify/core';
import Select from '@/components/ui/Select';
import { formatDate } from '@/components/ui/Modals/utils';
import { useResolution886Report } from '@/context/Resolution886Report';
import * as S from './styles';

interface VersionButtonProps {
	onVersionSelect: (version: string) => void;
}

export function VersionButton({ onVersionSelect }: VersionButtonProps): JSX.Element {
	const { report, selectedReviewId, lastReviewId, handleSetSelectedReviewId } = useResolution886Report();

	const [initialVersion, setInitialVersion] = useState<string>('');

	const createInitialVersionOption = () => ({
		value: initialVersion,
		label: `${I18n.get('Initial')} (${formatDate(report?.created_at)})`
	});

	const createRevisionOptions = (reviews: any[]) => {
		return reviews.slice(1).map((review, index) => ({
			value: review.id,
			label: `${I18n.get('Review')} ${index + 1} (${formatDate(review.created_at)})`
		}));
	};

	const createGeneralVersionOption = () => ({
		value: 'general',
		label: I18n.get('General Version')
	});

	const versions = [
		createInitialVersionOption(),
		...createRevisionOptions(report?.reviews || []),
		createGeneralVersionOption()
	];

	const handleVersionChange = (value: string): void => {
		handleSetSelectedReviewId(value);
		onVersionSelect(value);
	};

	const handleClearSelection = (): void => {
		handleVersionChange('initial');
	};

	useEffect(() => {
		if (lastReviewId) {
			handleSetSelectedReviewId(lastReviewId);
		}
	}, [lastReviewId, report]);

	useEffect(() => {
		setInitialVersion(report.reviews[0].id);
	}, [report]);

	return (
		<>
			<S.VersionTitle>{I18n.get('Version')}</S.VersionTitle>
			<Select
				style={{ width: '310px' }}
				allowClear
				options={versions}
				value={selectedReviewId}
				loading={false}
				disabled={false}
				onClear={handleClearSelection}
				onChange={handleVersionChange}
				placeholder="Select a version"
			/>
		</>
	);
}
